<template>
    <div class="ReferencesPage">
		<div class="ReferencesPage__header">
			<h2>Reference</h2>
		</div>
		<div class="ReferencesPage__content">
			<div 
				v-for="(name, index) in referenceNames" 
				:key="index" 
				class="ReferencesPage__content__item"
			>
				<img :src="require(`@/assets/images/references/${name}.png`)">
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ReferencesPage',
	data() {
		return {
			referenceNames: [
				'al-shiddi',
				'caparol',
				'orman',
				'fly-bosnia',
				'hydrometal',
				'lactalis',
				'orbico',
				'dukat',
				'plus',
				'sarajklima',
				'senigor',
				'sprind',
				'vipox'
			]
		}
	}
}
</script>

<style lang="scss" scoped>

.ReferencesPage {
	padding-top: 80px;

	&__header {
		padding: 20px 0;
		background: $blue;
		text-align: center;

		h2 {
			margin: 0;
			text-transform: uppercase;
			color: #FFF;
		}
	}
	&__content {
		width: 100%;
		display: grid;
		grid-template-columns: 1fr;
		justify-items: center;
		grid-gap: 50px;
		padding: 50px;

		@media screen and (min-width: 768px) {
			grid-template-columns: repeat(3, 1fr);
		}
		@media screen and (min-width: 1440px) {
			grid-template-columns: repeat(4, 1fr);
		}
		@media screen and (min-width: 1920px) {
			grid-template-columns: repeat(5, 1fr);
		}

		&__item {
			width: 80%;
			display: flex;
			align-items: center;
			justify-content: center;

			img {
				width: 100%;
			}
		}
	}
}
</style>
